import Application from 'umg-ember-backend/components/application';

<template>
  <Application>
    {{outlet}}
  </Application>
</template>
